/* eslint-disable import/no-extraneous-dependencies */
import React, { CSSProperties } from 'react';
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Textarea,
  TextareaProps,
} from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';
import _ from 'lodash';
import { extractErrorMessage } from '../../../../utils/ErrorUtils';

interface TextAreaInputFormProps extends TextareaProps {
  name: string | undefined | any;
  label: string | undefined;
  iconLeft?: JSX.Element;
  iconRight?: JSX.Element;
  labelStyles?: CSSProperties;
  infoButton?: JSX.Element;
  isRequired?: boolean;
  /** Espacamento do FormControl. Default 5 — quem monta grade propria passa 0. */
  controlMb?: number;
}

export const TextAreaInputForm = ({
  name,
  label,
  labelStyles,
  isRequired = false,
  controlMb = 5,
  ...rest
}: TextAreaInputFormProps) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const error = _.get(errors, name);
  return (
    <FormControl isRequired={isRequired} isInvalid={!!error} mb={controlMb}>
      {/*
        Condicional como no `InputForm`. Sem isto, `label={undefined}` +
        `isRequired` renderiza um FormLabel VAZIO com o RequiredIndicator
        dentro: asterisco vermelho orfao flutuando sobre o textarea, mais a
        altura fantasma do `mb`. Quem desenha o proprio rotulo passa
        `label={undefined}`.
      */}
      {label && (
        <FormLabel style={labelStyles} fontWeight="bold" mb={1} mr={3} htmlFor={name}>
          {label}
        </FormLabel>
      )}
      <Textarea
        id={name}
        background="body"
        isInvalid={!!error}
        errorBorderColor="red.400"
        minH="150px"
        {...register(name)}
        {...rest}
      />
      {error && <FormErrorMessage>{extractErrorMessage(error?.message)}</FormErrorMessage>}
    </FormControl>
  );
};
